/**
 * Web Style Import
 *
 */

import './style/dnb-label.scss'
